import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=3acb4b3e&scoped=true"
import script from "./Interview.vue?vue&type=script&lang=ts"
export * from "./Interview.vue?vue&type=script&lang=ts"
import style0 from "./Interview.vue?vue&type=style&index=0&id=3acb4b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb4b3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewMore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/view-more.vue').default})
